/**
 * Get currency symbol based on ISO 4217 3-digit currency code
 * @param currencyCode - ISO currency code (e.g., 'EUR', 'USD', 'CHF')
 * @returns Currency symbol or the currency code itself if not found
 */
export const getCurrencySymbol = (currencyCode?: string): string => {
  if (!currencyCode) return '€';

  const currencySymbols: Record<string, string> = {
    EUR: '€',
    CHF: 'CHF ',
    GBP: '£',
    USD: '$',
    CAD: '$',
    CNY: '¥',
    SGD: 'S$',
  };

  const upperCode = currencyCode.toUpperCase();
  return currencySymbols[upperCode] || upperCode;
};
